import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {RoleAnagrafModel} from '../../../../models/RoleAnagrafModel';
import {RoleAnagrafService} from '../../../general-services/service-role-anagraf/role-anagraf.service';
import * as toastr from 'toastr';

@Component({
  selector: 'app-edit-role-anagraf',
  templateUrl: './edit-role-anagraf.component.html',
  styleUrls: ['./edit-role-anagraf.component.scss']
})
export class EditRoleAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  roleAnagraf: RoleAnagrafModel;
  registerForm: FormGroup;
  formBuilder: FormBuilder;

  parameterSubscribe: Subscription;
  saveSubscribe: Subscription;
  submitted = false;

  id: number;
  roleCod: string;
  description: string;
  roleAnagrafJson: any;

  constructor(private route: ActivatedRoute, private router: Router,
              private roleAnagrafService: RoleAnagrafService, private _activatedRoute: ActivatedRoute) {
    super();

    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.roleAnagrafJson = params['row'];
      });

    this.roleAnagraf = new RoleAnagrafModel();

    this.formBuilder = new FormBuilder();

    this.registerForm = this.formBuilder.group({
      code: [{value: '', disabled: false}, Validators.required],
      description: [{value: '', disabled: false}, Validators.required]
    });
    this.roleAnagraf = JSON.parse(this.roleAnagrafJson) as RoleAnagrafModel;

    this.registerForm.patchValue({
      code: this.roleAnagraf ? this.roleAnagraf.code : ''
    });

    this.registerForm.patchValue({
      description: this.roleAnagraf ? this.roleAnagraf.description : ''
    });

    _activatedRoute.params.subscribe(params => {
      this.id = params['id'];
      this.roleCod = params['code'];
      this.description = params['description'];
    });
  }

  ngOnInit() {
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.ROLE_ANAGRF]);
  }

  edit() {
    this.submitted = true;
    if (this.registerForm.valid) {
      this.roleAnagraf.code = this.registerForm.controls['code'].value;
      this.roleAnagraf.description = this.registerForm.controls['description'].value;
      this.saveSubscribe = this.roleAnagrafService.update(this.roleAnagrafService.baseUrl, this.roleAnagraf).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Role Cod already exists', 'Warning');
          } else if (result === -2) {
            toastr.options.timeout = 5000;
            toastr.warning('Element already used', 'Warning');
          } else {
            toastr.success('Element was added with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.ROLE_ANAGRF]);
          }
        }, error => {
          toastr.error('Element has not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

}
